import { useState, useEffect } from "react";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    expandedFn: any;
};

const ExpandResultsBar = (props: Props) => {
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        props.expandedFn(isExpanded);
    }, [isExpanded]);

    const toggleView = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={"ExpandedResultsBar black w-100 h-2r d-flex justify-content-center align-items-center "}>
            <div data-testid={"expanded-result"} className={"inline-flex pointer"} onClick={toggleView}>
                <div className={"pointer"}>
                    <i
                        data-testid={"expanded-result-icon"}
                        className={isExpanded ? "fas fa-chevron-circle-up" : "fas fa-chevron-circle-down"}
                    />
                    <OwLabel title={isExpanded ? "view_less" : "view_more"} noBottomMargin={true} className={"pointer"} />
                </div>
            </div>
        </div>
    );
};

export default ExpandResultsBar;
